import { render, staticRenderFns } from "./fclAddonDataGrid.vue?vue&type=template&id=fb6b4e12&"
import script from "./fclAddonDataGrid.vue?vue&type=script&lang=js&"
export * from "./fclAddonDataGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb6b4e12')) {
      api.createRecord('fb6b4e12', component.options)
    } else {
      api.reload('fb6b4e12', component.options)
    }
    module.hot.accept("./fclAddonDataGrid.vue?vue&type=template&id=fb6b4e12&", function () {
      api.rerender('fb6b4e12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceFclAddon/components/fclAddonDataGrid.vue"
export default component.exports